<template>
    <v-container>
        <v-layout column>
            <v-form ref="form">
                <v-layout mb-3>
                    <v-flex>
                        <v-layout justify-end>
                            <div>
                                <v-menu content-class="menu-card mt-2 app-content flex"
                                        min-width="450px"
                                        transition="scale-transition"
                                        :close-on-content-click="false"
                                        offset-y
                                        full-width
                                        v-model="popupFiltro">
                                    <v-btn slot="activator" class="btn-default" color="dark" large outline>
                                        <v-icon color="primary">lnr-funnel</v-icon>
                                        <div class="pl-1">Filtrar</div>
                                    </v-btn>
                                    <v-layout column class="card" wrap>
                                        <v-layout>
                                            <v-flex class="mr-3">
                                                <v-label>De</v-label>
                                                <v-text-field :rules="[rules.date,rules.dataPassada]"
                                                              maxlength="10"
                                                              placeholder
                                                              v-model="filtro.de"
                                                              flat solo
                                                              validate-on-blur
                                                              mask="##/##/####"
                                                              return-masked-value></v-text-field>
                                            </v-flex>
                                            <v-flex>
                                                <v-label>Até</v-label>
                                                <v-text-field :rules="[rules.date,rules.dataPassada]"
                                                              maxlength="10"
                                                              placeholder
                                                              v-model="filtro.ate"
                                                              flat solo
                                                              validate-on-blur
                                                              mask="##/##/####"
                                                              return-masked-value></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-flex class="mb-4">
                                            <v-label>Login que distribuiu</v-label>
                                            <v-text-field ref="textField" flat solo hide-details
                                                          maxlength="100"
                                                          v-model="filtro.login_distribuiu"></v-text-field>
                                        </v-flex>
                                        <v-flex class="mb-4">
                                            <v-label>Login que recebeu</v-label>
                                            <v-text-field ref="textField" flat solo hide-details
                                                          maxlength="100"
                                                          v-model="filtro.login_recebeu"></v-text-field>
                                        </v-flex>
                                        <v-layout mt-3 justify-center>
                                            <v-label>Status</v-label>
                                            <v-flex class="md-6">
                                                <v-checkbox label="Qualificar"
                                                            v-model="filtro.status.qualificar"></v-checkbox>
                                                <v-checkbox class="mt-0" label="Qualificado"
                                                            v-model="filtro.status.qualificado"></v-checkbox>
                                                <v-checkbox class="mt-0" label="Com agendamento"
                                                            v-model="filtro.status.qualificado_com_agendamento"></v-checkbox>
                                                <v-checkbox class="mt-0" label="Cliente Aguardando Pagamento"
                                                            v-model="filtro.status.cliente_aguardando_pagamento"></v-checkbox>
                                                <v-checkbox class="mt-0" label="Cliente"
                                                            v-model="filtro.status.cliente"></v-checkbox>
                                            </v-flex>

                                            <v-flex class="md-6">
                                                <v-checkbox label="Desqualificado"
                                                            v-model="filtro.status.desqualificado"></v-checkbox>
                                                <v-checkbox class="mt-0" label="Negociação abandonada"
                                                            v-model="filtro.status.negociacao_realizada"></v-checkbox>
                                                <v-checkbox class="mt-0" label="Em negociação"
                                                            v-model="filtro.status.em_negociacao"></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout mt-3 justify-center>
                                            <v-flex xs4>
                                                <v-btn class="btn-default" color="dark" outline @click="limpar">Limpar
                                                </v-btn>
                                            </v-flex>
                                            <v-flex xs4>
                                                <v-btn class="btn-default primary" @click="filtrar">Filtrar</v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-layout>
                                </v-menu>
                            </div>
                            <div>
                                <v-btn class="btn-default" color="primary" large @click="exportToExcel">
                                    Exportar para Excel
                                </v-btn>
                            </div>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex md4 mr-4>
                        <v-layout>
                            <v-flex class="card text-md-center">
                                <h3 class="mb-3"><strong>informações do lead</strong></h3>
                                <img src="../assets/img/user_logo.png"
                                     alt="" style="width:70px;height:auto">
                                <p>{{lead.nome ||'Indísponível'}}</p>
                                <p class="small"><strong>Status: <span  :class="lead.status">{{getStatusAmortizado(lead.status) ||'Indísponível'}}</span></strong>
                                </p>
                                <v-layout justify-center>
                                    <v-btn class="btn-default shrink" color="dark" large outline>
                                        <v-icon color="primary" class="mr-1">phone</v-icon>
                                        {{lead.telefone ||'Indísponível'}}
                                    </v-btn>
                                </v-layout>
                                <v-flex class="text-md-left mt-3">
                                    <p v-if="lead.endereco" class="mb-1" style="font-size: 16px;">
                                        <v-icon color="primary" class="mr-1" style="font-size: 20px;">location_on
                                        </v-icon>
                                        {{lead.endereco}}
                                    </p>
                                    <p v-if="lead.email" class="mb-1" style="font-size: 16px;">
                                        <v-icon color="primary" class="mr-1" style="font-size: 20px;">mail</v-icon>
                                        {{lead.email}}
                                    </p>
                                    <p v-if="lead.cidade" class="mb-1" style="font-size: 16px;">
                                        <v-icon color="primary" class="mr-1" style="font-size: 20px;">location_on</v-icon>
                                        {{lead.cidade.nome}}
                                    </p>
                                    <p class="mb-1" style="font-size: 16px;">
                                        <v-icon color="primary" class="mr-1" style="font-size: 20px;">commute</v-icon>
                                        {{getProdutoInteresse(lead.produto_interesse) | capitalize}}
                                    </p>
                                    <p v-if="lead.origem && lead.origem.origem" class="mb-1" style="font-size: 16px;">
                                        <v-icon color="primary" class="mr-1" style="font-size: 20px;">description</v-icon>
                                        {{lead.origem.origem | capitalize}}
                                    </p>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex md8>
                        <v-layout>
                            <v-flex class="card">
                                <v-timeline  dense>
                                    <v-timeline-item
                                            v-for="(item,i) in lead.historico"
                                            :key="i"
                                            color="primary"
                                            icon="tune"
                                            right
                                            dark
                                            large
                                            fill-dot>
                                        <div v-if="item.tipo == 'desqualificacao'" class="py-3">
                                            <h2 class="`headline mb-5`">Desqualificado</h2>
                                            <p class="mb-0">Motivo: <strong>{{item.motivo }} {{ statusOutros(item.outros)}} !!</strong></p>
                                            <p class="mb-0">Desqualificado por: <strong>{{item.usuario}}</strong></p>
                                            <p><i>Em {{item.data_hora_criacao}} </i></p>
                                        </div>
                                        <div v-if="item.tipo == 'distribuicao'" class="py-3">
                                            <h2 class="`headline mb-5`">Distribuído</h2>
                                            <p class="mb-0">Recebido por: <strong>{{item.usuario}}</strong></p>
                                            <p class="mb-0">Status anterior: <strong>{{getStatusAmortizado(item.status_anterior)}}</strong> </p>
                                            <p><i>Em {{item.data_hora_criacao}} </i></p>
                                        </div>
                                        <div v-if="item.tipo == 'alteracao_status'" class="py-3">
                                            <h2 class="`headline mb-5`">Status alterado</h2>
                                            <p class="mb-0">Alterou para o Status: <strong>{{getStatusAmortizado(item.status)}}</strong> </p>
                                            <p class="mb-0">Feito por <strong>{{item.usuario}}</strong>, via <strong>{{item.canal}}</strong></p>
                                            <p><i>Em {{item.data_hora_criacao}} </i></p>
                                        </div>
                                        <div v-if="item.tipo == 'sla'" class="py-3">
                                            <h2 class="`headline mb-3`">Encaminhamento por SLA</h2>
                                            <p class="mb-0">Lead perdido por: <strong>{{item.usuario}}</strong></p>
                                            <p class="mb-0">Status anterior: <strong>{{getStatusAmortizado(item.status_anterior)}}</strong> </p>
                                            <p><i>Em {{item.data_hora_criacao}} </i></p>
                                        </div>
                                    </v-timeline-item>
                                    <v-timeline-item
                                            color="primary"
                                            icon="tune"
                                            v-if="lead.origem"
                                            right
                                            dark
                                            large
                                            fill-dot>
                                        <div class="py-3">
                                            <h2 class="`headline mb-5`">Lead recebido</h2>
                                            <p class="mb-0">Origem: <strong>{{lead.origem.origem | capitalize}}</strong> </p>
                                            <p class="mb-0">Atribuído à: <strong>{{lead.origem.vendedor}}</strong>, via <strong>{{lead.origem.canal}}</strong></p>
                                            <p><i>Em {{lead.origem.data_hora_criacao}} </i></p>
                                        </div>
                                    </v-timeline-item>
                                </v-timeline>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-layout>
    </v-container>
</template>

<script>
import Rules from '../plugins/validation'
import Filters from '../plugins/filters'
import { alert, error, sleep } from '../plugins/helpers'
import { events } from '../plugins/events'
import moment from 'moment'

const listagem = 'unidades_negocio'

export default {
  computed: {
    produtos () {
      return {
        '1': 'AUTOMOVEIS',
        '2': 'MOTOCICLETAS',
        '4': 'IMOVEIS',
        '5': 'OUTROS BENS MOVEIS',
        '7': 'SERVIÇOS',
        '11': 'MAQ. E EQUIP.AGRICOLAS',
        '301': 'MEU AUTOMÓVEL',
        '302': 'MEU IMÓVEL'
      }
    },
    rules: () => Rules
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString().replace('_', ' ')
      return value.charAt(0).toUpperCase() + value.slice(1).toLocaleLowerCase()
    },
    ...Filters
  },
  data: () => ({
    filtro: {
      de: '',
      ate: '',
      login_distribuiu: '',
      login_recebeu: '',
      status: {
        qualificar: false,
        desqualificado: false,
        qualificado: false,
        negociacao_realizada: false,
        qualificado_com_agendamento: false,
        em_negociacao: false,
        cliente_aguardando_pagamento: false,
        cliente: false
      }
    },
    statusAmortizado: {
      qualificar: 'Qualificar',
      qualificado: 'Qualificado',
      desqualificado: 'Desqualificado',
      negociacao_realizada: 'Negociação abandonada',
      em_negociacao: 'Em Negociação',
      qualificado_com_agendamento: 'Qualificado com agendamento',
      cliente_aguardando_pagamento: 'Cliente Aguardando Pagamento',
      cliente: 'Cliente'
    },
    edicao: false,
    popupFiltro: false,
    model: {
      id_unidade_negocio: '',
      codigo: '',
      nome: ''
    },
    lead: {
      origem: {},
      historico: []
    }
  }),
  methods: {
    salvar () {
      const form = this.$refs.form

      if (form.validate()) {
        (this.edicao
          ? this.$http.put(`/admin/unidadesnegocio/${this.model.id_unidade_negocio}`, this.model)
          : this.$http.post('/admin/unidadesnegocio', this.model)).then(() => {
          alert({
            text: `Unidade de negócio ${this.edicao ? 'alterada' : 'cadastrada'} com sucesso!`,
            buttons: {
              'OK': () => {
                const id_usuario = this.$session.get('id_usuario')
                events.$emit('atualizar-unidade', id_usuario)
                this.$router.push({ name: listagem })
              }
            }
          })
        }).catch(err => {
          error(err, 'Não foi possível salvar as informações.')
        })
      } else {
        form.resetValidation()
        sleep(100).then(() => form.validate())
      }
    },
    filtrar () {
      this.popupFiltro = false
      this.timeline()
    },
    limpar () {
      this.filtro = {
        de: '',
        ate: '',
        login_distribuiu: '',
        login_recebeu: '',
        status: {
          qualificar: false,
          desqualificado: false,
          qualificado: false,
          negociacao_realizada: false,
          com_agendamento: false,
          em_negociacao: false,
          cliente_aguardando_pagamento: false,
          cliente: false
        }
      }
      this.filtrar()
    },
    timeline () {
      if ('id_lead' in this.$route.params) {
        const id_lead = this.$route.params['id_lead']
        let params = this.filtro
        params.id_unidade_negocio = this.$session.get('id_unidade_negocio')
        this.$http.get(`/admin/leads/${id_lead}`, { params }).then((r) => {
          this.lead = r.data
          if (this.lead.origem) {
            this.lead.origem.data_hora_criacao = moment(r.data.origem.data_hora_criacao).format('LLL')
          }

          r.data.historico.forEach((item, i) => {
            this.lead.historico[i].data_hora_criacao = moment(item.data_hora_criacao).format('LLL')
          })
        }).catch(err => {
          error(err, 'Não foi possível recuperar as informações.')
        })
      }
    },
    getStatusAmortizado (status) {
      return this.statusAmortizado[status]
    },
    statusOutros (status) {
      if (status !== 'null') {
        return ': ' + status
      }
    },
    exportToExcel () {
      const id_lead = this.$route.params['id_lead']

      let params = {}

      params.filtros = this.filtro
      params.id_unidade_negocio = this.$session.get('id_unidade_negocio')
      params.tipo = 'historico'

      this.$http.get(`/admin/leads/export/detalhe/${id_lead}`, {
        responseType: 'blob',
        params
      }).then((r) => {
        const url = window.URL.createObjectURL(new Blob([r.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'export_detalhe.xlsx')
        document.body.appendChild(link)
        link.click()
      })
        .catch(err => {
          error(err, 'Não foi possível recuperar as informações.')
        })
    },
    getProdutoInteresse (id_produto) {
      return this.produtos[id_produto] || 'Não informado'
    }
  },
  mounted () {
    this.timeline()
  }
}
</script>

<style scoped>
    /*span.negociacao_realizada,*/
    /*span.qualificado {*/
        /*color: #72C151;*/
    /*}*/

    /*span.qualificado_com_agendamento,*/
    /*span.em_negociacao,*/
    /*span.qualificar {*/
        /*color: #F2CC34;*/
    /*}*/

    /*span.inativo {*/
        /*color: #999999;*/
    /*}*/

    /*span.desqualificado{*/
        /*color: #FF6666;*/
    /*}*/

</style>
